// remove url params
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

export const BLACKLISTED_PARAMS: ReadonlyArray<string> = [
  'token',
  'userToken',
  'msUserToken',
];

export const removeBlackListedPrams = () => {
  const urlParams = queryString.parse(location.search);

  if (!hasBlacklistedParams(urlParams)) return;

  const allowedParams = omit(urlParams, BLACKLISTED_PARAMS);

  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${
      !isEmpty(allowedParams) ? `?${queryString.stringify(allowedParams)}` : ''
    }`,
  );
};

export const injectGoogleTagManager = (measurementId: string) => {
  const urlParams = queryString.parse(location.search);

  // We should not initialize analytics if we have blacklisted url params
  if (hasBlacklistedParams(urlParams)) return;

  const head = document.getElementsByTagName('head')[0];

  const gtagScript = document.createElement('script');
  gtagScript.type = 'text/javascript';
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  gtagScript.async = true;

  head?.appendChild(gtagScript);
};

export function hasBlacklistedParams(urlParams: Record<string, string>) {
  return Object.keys(urlParams).some((k: string) =>
    BLACKLISTED_PARAMS.includes(k),
  );
}
